import { render, staticRenderFns } from "./organizerApply.vue?vue&type=template&id=c6344d84&scoped=true&"
import script from "./organizerApply.vue?vue&type=script&lang=js&"
export * from "./organizerApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6344d84",
  null
  
)

export default component.exports